import {
    FETCH_ALL_USERS,
    FETCH_ALL_USERS_SUCCESS,
    FETCH_ALL_USERS_FAILED,
    FETCH_ALL_USERS_STATIC,
    FETCH_ALL_USERS_STATIC_SUCCESS,
    FETCH_ALL_USERS_STATIC_FAILED,
    FETCH_CUSTOMERS_PAGE,
    FETCH_CUSTOMERS_PAGE_SUCCESS,
    FETCH_CUSTOMERS_PAGE_FAILED,
    EDIT_USER,
    UPSERT_USER,
    REMOVE_USER,
    FETCH_ALL_DRIVERS,
    FETCH_ALL_DRIVERS_SUCCESS,
    FETCH_ALL_DRIVERS_FAILED
  } from "../store/types";

  export const INITIAL_STATE = {
    users:null,
    staticusers:null,
    drivers: null,
    // Paginated customer list (Riders view) fed from /customer_index instead
    // of the full /users tree. `rows` accumulates fetched pages newest-first;
    // `byId` dedups; `cursor` is the oldest createdAt loaded; `stats` mirrors
    // /customer_index_stats for the count tiles.
    customers: {
      rows: [],
      byId: {},
      cursor: null,
      hasMore: true,
      stats: null,
      loading: false,
      error: null
    },
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export const usersreducer =  (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_ALL_USERS:
        return {
          ...state,
        };
      case FETCH_ALL_USERS_SUCCESS:
        return {
          ...state,
          users:action.payload,
        };
      case FETCH_ALL_USERS_FAILED:
        return {
          ...state,
          users:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      case FETCH_ALL_DRIVERS:
        return {
          ...state
        };
      case FETCH_ALL_DRIVERS_SUCCESS:
        return {
          ...state,
          drivers:action.payload
        };
      case FETCH_ALL_DRIVERS_FAILED:
        return {
          ...state,
          drivers:null,
          error:{
            flag:true,
            msg:action.payload
          }
        };  
      case FETCH_ALL_USERS_STATIC:
        return {
          ...state,
          loading:true
        };
      case FETCH_ALL_USERS_STATIC_SUCCESS:
        return {
          ...state,
          staticusers:action.payload,
          loading:false
        };
      case FETCH_ALL_USERS_STATIC_FAILED:
        return {
          ...state,
          staticusers:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      case FETCH_CUSTOMERS_PAGE:
        return {
          ...state,
          customers: { ...state.customers, loading: true, error: null }
        };
      case FETCH_CUSTOMERS_PAGE_SUCCESS: {
        const { rows = [], nextCursor = null, hasMore = false, reset = false, stats } = action.payload || {};
        const baseById = reset ? {} : { ...state.customers.byId };
        const baseRows = reset ? [] : state.customers.rows.slice();
        rows.forEach(r => {
          if (r && r.id && !baseById[r.id]) {
            baseById[r.id] = r;
            baseRows.push(r);
          } else if (r && r.id) {
            baseById[r.id] = { ...baseById[r.id], ...r };
            const idx = baseRows.findIndex(x => x.id === r.id);
            if (idx >= 0) baseRows[idx] = baseById[r.id];
          }
        });
        // A stats-only update (no rows, no reset — e.g. fetchCustomerStats)
        // must NOT clobber an active pagination cursor/hasMore.
        const isStatsOnly = !reset && rows.length === 0;
        return {
          ...state,
          customers: {
            ...state.customers,
            rows: baseRows,
            byId: baseById,
            cursor: isStatsOnly ? state.customers.cursor : nextCursor,
            hasMore: isStatsOnly ? state.customers.hasMore : hasMore,
            stats: stats !== undefined ? stats : state.customers.stats,
            loading: false,
            error: null
          }
        };
      }
      case FETCH_CUSTOMERS_PAGE_FAILED:
        return {
          ...state,
          customers: { ...state.customers, loading: false, error: action.payload }
        };
      case EDIT_USER:
        return state;
      // Surgical upsert into both `users` (admin-excluded) and `staticusers`
      // (everyone) arrays. Merges the patch into an existing entry or
      // appends if absent. Respects the admin-exclusion contract on `users`.
      // Triggered by cache patch helpers so live components (DriverDetails
      // wallet/topup tab, UserRides, Withdraws) re-render with fresh data
      // immediately, without waiting for a full /users refetch.
      case UPSERT_USER: {
        const id = action.payload && action.payload.id;
        const patch = action.payload && action.payload.patch;
        if (!id || !patch) return state;

        const upsert = (arr, excludeAdmin) => {
          if (!Array.isArray(arr)) return arr;
          const idx = arr.findIndex(u => u.id === id);
          if (idx >= 0) {
            const merged = { ...arr[idx], ...patch, id };
            // If the patch flipped usertype to admin and this array
            // excludes admins, drop the entry entirely.
            if (excludeAdmin && merged.usertype === 'admin') {
              return arr.filter(u => u.id !== id);
            }
            const next = arr.slice();
            next[idx] = merged;
            return next;
          }
          // Not present — only insert if rules allow it.
          if (excludeAdmin && patch.usertype === 'admin') return arr;
          return [...arr, { ...patch, id }];
        };

        // Keep the paginated customers slice coherent: if this record is
        // already loaded in a page, merge the patch in place (or drop it if it
        // stopped being a customer). Never inject a brand-new customer here —
        // the paginated list only holds what was actually fetched.
        let customers = state.customers;
        if (customers && customers.byId && customers.byId[id]) {
          const merged = { ...customers.byId[id], ...patch, id };
          if (merged.usertype && merged.usertype !== 'customer') {
            const byId = { ...customers.byId }; delete byId[id];
            customers = { ...customers, byId, rows: customers.rows.filter(u => u.id !== id) };
          } else {
            const byId = { ...customers.byId, [id]: merged };
            customers = { ...customers, byId, rows: customers.rows.map(u => u.id === id ? merged : u) };
          }
        }

        return {
          ...state,
          users: upsert(state.users, true),
          staticusers: upsert(state.staticusers, false),
          customers,
        };
      }
      case REMOVE_USER: {
        const id = action.payload;
        if (!id) return state;
        const remove = (arr) => Array.isArray(arr) ? arr.filter(u => u.id !== id) : arr;
        let customers = state.customers;
        if (customers && customers.byId && customers.byId[id]) {
          const byId = { ...customers.byId }; delete byId[id];
          customers = { ...customers, byId, rows: customers.rows.filter(u => u.id !== id) };
        }
        return {
          ...state,
          users: remove(state.users),
          staticusers: remove(state.staticusers),
          customers,
        };
      }
      default:
        return state;
    }
  };